import { takeLatest } from 'redux-saga/effects';
import {
	getUserFarmersSuccess, getUserFarmersFail,
	getUserFarmsSuccess, getUserFarmsFail,
	getAnimalConditionsSuccess, getAnimalConditionsFail,
	getAnimalTypesSuccess, getAnimalTypesFail,
	getCattleBreedsSuccess, getCattleBreedsFail,
	getHornStatusSuccess, getHornStatusFail,
    getGoatBreedsSuccess, getGoatBreedsFail,
    getSheepBreedsSuccess, getSheepBreedsFail,
} from './dynamicListState';
import createCrudService from '../../services/crudservice';
import { doCrudCall } from '../../utils/crudSagaHelper';

const crudService = createCrudService('api/v1/admin');
const optionService = createCrudService('api/v1/services/option-items');

function* getUserFarmers(data) {	
	yield doCrudCall(
		() => crudService.doGetRequest('user-details', data.payload), 
		getUserFarmersSuccess, 
		getUserFarmersFail);
}

function* getUserFarms(data) {	
	yield doCrudCall(
		() => crudService.doGetRequest(`farm-parcels`, data.payload), 
		getUserFarmsSuccess, 
		getUserFarmsFail);
}

function* getAnimalConditions(data) {	
	yield doCrudCall(
		() => optionService.doGetRequest(`farm-animal-conditions`, data.payload), 
		getAnimalConditionsSuccess, 
		getAnimalConditionsFail);
}

function* getAnimalTypes(data) {	
	yield doCrudCall(
		() => optionService.doGetRequest(`LIVESTOCK_TYPE`, data.payload), 
		getAnimalTypesSuccess, 
		getAnimalTypesFail);
}

function* getCattleBreeds(data) {
	yield doCrudCall(
		() => optionService.doGetRequest('CATTLE_BREED',data.payload), 
		getCattleBreedsSuccess, 
		getCattleBreedsFail);
}

function* getHornStatus(data) {
	yield doCrudCall(
		() => optionService.doGetRequest('HORN_STATUS',data.payload), 
		getHornStatusSuccess, 
		getHornStatusFail);
}

function* getGoatBreeds(data) {
	yield doCrudCall(
		() => optionService.doGetRequest('GOAT_BREED',data.payload), 
		getGoatBreedsSuccess, 
		getGoatBreedsFail);
}

function* getSheepBreeds(data) {
	yield doCrudCall(
		() => optionService.doGetRequest('SHEEP_BREED',data.payload), 
		getSheepBreedsSuccess, 
		getSheepBreedsFail);
}

function* dynamicListSaga() {
  yield takeLatest('dynamicList/getUserFarmers', getUserFarmers);
  yield takeLatest('dynamicList/getUserFarms', getUserFarms);
  yield takeLatest('dynamicList/getAnimalConditions', getAnimalConditions);
  yield takeLatest('dynamicList/getAnimalTypes', getAnimalTypes);
  yield takeLatest('dynamicList/getCattleBreeds', getCattleBreeds);
  yield takeLatest('dynamicList/getHornStatus', getHornStatus);
  yield takeLatest('dynamicList/getGoatBreeds', getGoatBreeds);
  yield takeLatest('dynamicList/getSheepBreeds', getSheepBreeds);
}

export default dynamicListSaga;
